<template>
  <etg-img
    v-if="isDefaultAvatarShown"
    src="/images/avatar-review-member.png"
    alt="avatar"
    class="rounded-full size-8 object-cover"
    :use-webp="true"
  />
  <div v-else class="rounded-full size-8 text-gray-10 bg-red-50 flex items-center justify-center">
    {{ commenterFirstLetter }}
  </div>
</template>

<script lang="ts" setup>
interface Props {
  username?: string
}

const props = defineProps<Props>()
const { username } = toRefs(props)

const { isDefaultAvatarShown, commenterFirstLetter } = useComment(username)
</script>
